import React,{useEffect,useState,useRef} from 'react'
import { useAuthContext } from '../../context/Auth/Create'
import {Dashboard,FR} from '../../sdk'
import { Loader } from '../Default'
import { DateTime } from './DateTime'

export const CompanyRealTimeBlocks=(props) =>{
	const userAuth=useAuthContext();
	
	console.log("here")
	const [state,setState]=useState({loader:true,tab:"company",employeeWise:1,companyName:userAuth.user.companyName,departmentName:userAuth.user.departmentName,
		companies:[],
		departments:[]});
		const ref2=useRef({
			employeeWise:1,companyName:userAuth.user.companyName,departmentName:userAuth.user.departmentName
})
	
	const realimeData=async()=>{
		try{
		  let result=await new Dashboard().statistics({employeeWise:ref2.current.employeeWise,companyName:ref2.current.companyName,departmentName:""});
		  
		   setState((pre)=>{
			return {...pre,...result,loader:false}
		   })
	
		}catch(e){
	    alert("click ok to continue")
		}
	  }
	  const apiData=async()=>{
		try{
		let users=await new FR().getCompanies();
		let departments=[]
		let find=users.find(val=>val.companyName===state.companyName);
			if(find){
			 departments=find.departments;
			}
		
		setState((pre)=>{
		  return {...pre,companies:users,loader:false,departments}
	   })
	   }catch(e){
		console.log(e)
		alert("error occur")
		}
	
	}
	useEffect(()=>{
		apiData();
		},[])
	  useEffect(()=>{
	  realimeData()
	  userAuth.socket.on('getAttendance',realimeData);
	  return ()=>{
	  userAuth.socket.off('getAttendance',realimeData);
	  }
	//   const setTime=setInterval(()=>realimeData(),1000 *1)
	//   return ()=>{
	// 	clearInterval(setTime)
	//   }
	  },[])
	  
	  useEffect(()=>{
	  window.$('[data-toggle="tooltip"]').tooltip(); 
	  },[state.loader])
	  if(!state.loader){
		let occurancePersmission=0;
        for(let val of props.headData){
			if(userAuth.user.permissions.includes(val.role)){
                occurancePersmission++;
			}
		}
		const onHandlerType=(event)=>{
			let key=event.target.name;
			let value=event.target.value;
			if(key==="companyName"){
			let departments=[];
			let find=state.companies.find(val=>val.companyName===value);
			if(find){
			 departments=find.departments;
			}
			ref2.current={...ref2.current,[key]:value}
			setState((pre)=>{
			  return{...pre,departments,department:""}
			})
			}
			else{
				ref2.current={...ref2.current,[key]:value}
			 setState((pre)=>{
			   return{...pre,[key]:value,[key]:value}
			 })
			}
			
		   }
	  return (<>
		{/* {
			props.headData.map((val,index)=>{
				if(userAuth.user.permissions.includes(val.role)){
					return (
						<>
						<div key={` for-${index}`} className={`col-xl-${colWidth} col-lg-6`}>
									 
										 <div className="card mb-3">
											 
											 <div className="card-body">
											  
												 <div className="d-flex fw-bold small mb-3">
													 <span className="flex-grow-1">{val.name}</span>
												 
												 </div>
											 
												 <div className="row align-items-center mb-2">
													 <div className="col-7">
														 <h3 className="mb-0">
															{val.name==="Enter Count" && state.footFall}
															{val.name==="Person Occupancy" && state.occupancy}
															{val.name==="Vehicle Count" && state.vehicleFootfall}
															{val.name==="Vehicle Occupancy" && state.vehicleOccupancy}
	
														   
														 </h3>
													 </div>
													
													 
												 </div>
											 
											
											 
											 </div>
										 
											 <div className="card-arrow">
											 <div className="card-arrow-top-left"></div>
												 <div className="card-arrow-top-right"></div>
												 <div className="card-arrow-bottom-left"></div>
												 <div className="card-arrow-bottom-right"></div>
											 </div>
										 
										 </div>
									 
									 </div>
						</>
					   )
				}
				else{
					return false;
				}
			
			})
			
           
		} */}
		 
      
	 
		  {/* BEGIN col-9 */}
		  <div className="col-xl-12" style={{textAlign:"center"}}>
			<div id="hoverableRows" className="mb-5">
			  <h4 style={{textAlign:"center"}}>Live Data</h4>
			 
			  <div className="card">
				<div className="card-body" >
				<DateTime/>
				{(userAuth.user && userAuth.user.permissions.includes("Person Counting")) &&<>
					{!userAuth.user.isHightAuthority && <><div style={{display: "flex",flexDirection: "column",alignItems: "center",justifyContent:"center",height:"50vh",color:'#04FC3C'}}>
					
					<div style={{textAlign:"center",width:"100%",}}>
					<table className="table table-hover table-bordered mb-0" style={{textAlign:"center"}}>
					  <thead>
						<tr>
						  <th scope="col"><h1 style={{fontSize:'42px',color:'#3cd2a5'}}>{state.footFall} <span style={{fontSize:'20px'}}>People In</span></h1></th>
						  <th scope="col"><h1 style={{fontSize:'42px',color:'#3cd2a5'}}>{state.totalExit} <span style={{fontSize:'20px'}}>People Out</span></h1></th>
						  <th scope="col"><h1 style={{fontSize:'42px',color:'#3cd2a5'}}>{state.lastNightOccupancy} <span style={{fontSize:'20px'}}>Last Night Occupancy</span></h1></th>
						</tr>
					  </thead>
					</table>
					</div>
					<div  style={{textAlign:"center",width:"100%",marginTop:"2rem"}}>
						  <h1 style={{fontSize:'42px',color:'#3cd2a5'}} data-toggle="tooltip" data-placement="top" title="(people in - people out)">{Number(state.occupancy) + Number(state.lastNightOccupancy)} <span style={{fontSize:'20px'}}> Current Occupancy</span></h1>
					</div>
					  </div></>}
					  {userAuth.user.isHightAuthority && <>
					  
					  <div style={{display: "flex",flexDirection: "column",justifyContent:"center",height:"50vh",color:'#04FC3C',marginTop:"1rem"}}>
					
{state.tab==="company" && <>

	<div className="card">
<div className="card-body" >
					  <div style={{textAlign:"center",width:"100%",}}>
						<div className="row" style={{marginBottom:"1rem",justifyContent:"end"}}>

						
					  <div className="col-sm-12 col-md-5 col-lg-3">
      <div class="form-group mb-3">
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect1" ></label>
        <select class="form-select" name="companyName" id="exampleFormControlSelect1" onChange={onHandlerType} style={{color:"rgb(60, 210, 165)"}}>
          <option value="" selected={state.companyName===""}>Company</option>
          {state.companies.map((val,index)=>{
            return  <option key={index} value={val.companyName} selected={state.companyName===val.companyName}>{val.companyName}</option>
          })}
         
          
          </select>
          </div>
       </div>
      
	   </div>
					  <table className="table table-hover table-bordered mb-0" style={{textAlign:"center"}}>
					  <thead>
						<tr>
						  <th scope="col"><h1 style={{fontSize:'42px',color:'#3cd2a5'}}>{state.footFall} <span style={{fontSize:'20px'}}>People In</span></h1></th>
						  <th scope="col"><h1 style={{fontSize:'42px',color:'#3cd2a5'}}>{state.totalExit} <span style={{fontSize:'20px'}}>People Out</span></h1></th>
						  {/* <th scope="col"><h1 style={{fontSize:'42px',color:'#3cd2a5'}}>{state.lastNightOccupancy} <span style={{fontSize:'20px'}}>Last Night Occupancy</span></h1></th> */}
						</tr>
					  </thead>
					</table>
					</div>
					<div  style={{textAlign:"center",width:"100%",marginTop:"2rem"}}>
						  <h1 style={{fontSize:'42px',color:'#3cd2a5'}} data-toggle="tooltip" data-placement="top" title="(people in - people out)">{state.occupancy} <span style={{fontSize:'20px'}}>Current Occupancy</span></h1>
					</div>
					  </div>
					  <div className="card-arrow">
				  <div className="card-arrow-top-left" />
				  <div className="card-arrow-top-right" />
				  <div className="card-arrow-bottom-left" />
				  <div className="card-arrow-bottom-right" />
				</div>
					</div>
</>}

{state.tab==="building" && <>


				  <div style={{textAlign:"center",width:"100%",}}>
				  <table className="table table-hover table-bordered mb-0" style={{textAlign:"center"}}>
				  <thead>
					<tr>
					  <th scope="col"><h1 style={{fontSize:'42px',color:'#3cd2a5'}}>{state.footFall} <span style={{fontSize:'20px'}}>People In</span></h1></th>
					  <th scope="col"><h1 style={{fontSize:'42px',color:'#3cd2a5'}}>{state.totalExit} <span style={{fontSize:'20px'}}>People Out</span></h1></th>
					  <th scope="col"><h1 style={{fontSize:'42px',color:'#3cd2a5'}}>{state.lastNightOccupancy} <span style={{fontSize:'20px'}}>Last Night Occupancy</span></h1></th>
					</tr>
				  </thead>
				</table>
				</div>
				<div  style={{textAlign:"center",width:"100%",marginTop:"2rem"}}>
					  <h1 style={{fontSize:'42px',color:'#3cd2a5'}} data-toggle="tooltip" data-placement="top" title="(people in - people out) + last night occupancy">{Number(state.occupancy) + Number(state.lastNightOccupancy)} <span style={{fontSize:'20px'}}>Current Occupancy</span></h1>
				</div>
				  
				 
				
</>}

					</div>
					  </>}
				</>}
					
					
			
				</div>
				<div className="card-arrow">
				  <div className="card-arrow-top-left" />
				  <div className="card-arrow-top-right" />
				  <div className="card-arrow-bottom-left" />
				  <div className="card-arrow-bottom-right" />
				</div>
			 
			  </div>
			</div>
		  </div>
		 
	
		</>)
	
	  }
	  else{
		return (<>
		<Loader/>
		</>)
	  }
	
    
}
